export default {"src":"/_next/static/media/icon.7ceb1ae9.svg","height":89,"width":87,"blurWidth":0,"blurHeight":0};